import { render, staticRenderFns } from "./StageScore.vue?vue&type=template&id=d4cbc4ca&"
import script from "./StageScore.vue?vue&type=script&lang=js&"
export * from "./StageScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports